import { cn } from './cn';

const variants = {
  primary: 'bg-brand-400 text-on-brand hover:brightness-110 disabled:bg-brand-400/40',
  // Sem contorno: o tom do fundo é o botão; o hover sobe um degrau.
  secondary: 'bg-surface-2 text-fg hover:bg-surface-3 disabled:text-fg-subtle disabled:hover:bg-surface-2',
  ghost: 'text-fg-muted hover:bg-surface-2 hover:text-fg',
  danger: 'bg-red-500/10 text-red-300 light:text-red-700 hover:bg-red-500/18',
} as const;

const sizes = {
  sm: 'h-8 px-3 text-sm gap-1.5',
  md: 'h-10 px-4 text-sm gap-2',
  lg: 'h-12 px-6 text-base gap-2',
} as const;

export type ButtonVariant = keyof typeof variants;
export type ButtonSize = keyof typeof sizes;

export function buttonClass(variant: ButtonVariant = 'primary', size: ButtonSize = 'md') {
  return cn(
    'inline-flex shrink-0 items-center justify-center rounded-xl font-medium transition-[background-color,color,transform,filter] duration-200 ease-out active:scale-[0.98] disabled:cursor-not-allowed disabled:active:scale-100',
    variants[variant],
    sizes[size],
  );
}
